import React from 'react';

import { FileToolsetSettingsOutput } from '../../../../../../gamma-api';

import BaseToolsetListItem from './BaseToolsetListItem';

import { IToolsetListItemProps } from './index';

const FileToolset: React.FC<IToolsetListItemProps> = ({ toolset, onSetup, onDelete, onToolsetStateChange }) => {
  const settings = toolset.settings as FileToolsetSettingsOutput;

  const getToolCount = () => {
    let toolCount = 0;
    settings.write_file_tool_settings.enabled && toolCount++;
    settings.read_file_tool_settings.enabled && toolCount++;
    settings.describe_image_tool_settings.enabled && toolCount++;
    return toolCount;
  };

  return (
    <BaseToolsetListItem
      toolCount={getToolCount()}
      toolset={toolset}
      onDelete={onDelete}
      onSetup={onSetup}
      onToolsetStateChange={onToolsetStateChange}
    />
  );
};

export default FileToolset;
